import { IFlowChangePrices } from '../change-prices/flow-change-prices.interface';
import { IFlowGoodsReceipt } from '../goods-receipts/flow-goods-receipt.interface';
import { IFlowOrder } from '../orders/flow-order.interface';

/**
 * All registered flow types in the PBGAS project.
 * Use these constants instead of bare strings for type-safe flow type references.
 * The string value must match the `type` declared in the corresponding IFlowHandler.
 */
export enum FlowType {
  order = 'order',
  changePrices = 'change-prices',
  goodsReceipt = 'goods-receipt',
}

export type FlowDataMap = {
  [FlowType.order]: IFlowOrder;
  [FlowType.changePrices]: IFlowChangePrices;
  [FlowType.goodsReceipt]: IFlowGoodsReceipt;
};
export type DeliveriesFlowType = FlowType.order;

export type DeliveryFlow = FlowDataMap[DeliveriesFlowType];
